exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Example Media queries\n *\n * @media (max-width: @kng-screen-xs-max) { ... }\n * @media (min-width: @kng-screen-sm-min) and (max-width: @kng-screen-sm-max) { ... }\n * @media (min-width: @kng-screen-md-min) and (max-width: @kng-screen-md-max) { ... }\n * @media (min-width: @kng-screen-lg-min) { ... }\n *\n */\n.home-button {\n  float: right;\n  margin-right: 10px;\n}\n.home-button.interactive:hover,\n.home-button.interactive:focus {\n  cursor: pointer;\n}\n.home-button.interactive:active {\n  cursor: pointer;\n}\n.home-button .kng-icon-home {\n  font-size: 24px;\n  padding: 14px 10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/components/home-button/home-button.component.less
// module id = ../../../../../src/app/components/home-button/home-button.component.less
// module chunks = main